<template>
  <div class="personnel-on-duty-classes-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;">
        <button-add :pathName="addAccountRouterName" value="添加班次" v-if="permissionCodes.indexOf('004036001') !== -1"/>
      </div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @lookOver="viewClassesTime" @deleteLine="deleteLine" @goToModifyPage="goToModifyPage" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />


    <el-dialog :title="classesTimeTitle" :visible.sync="classesTimeDialogVisible" width="600px">
      <div class="classes-time-main">
        <div class="classes-time-line">
          <div class="classes-time-title">周一：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.monTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.monTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周二：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.tueTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.tueTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周三：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.wedTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.wedTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周四：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.thuTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.thuTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周五：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.friTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.friTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周六：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.satTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.satTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
        <div class="classes-time-line">
          <div class="classes-time-title">周日：</div>
          <div class="classes-time-no-tip" v-if="currentClassesInfo.sunTimes.length === 0">当天暂无班次时间</div>
          <div class="classes-time-info" v-for="timeInfo in currentClassesInfo.sunTimes">
            <div class="classes-time-info-item">{{timeInfo.startTime}} ~ {{timeInfo.endTime}}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="classesTimeDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "personnel-on-duty-classes-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {value: "智慧停车", name: "parking-device-management"},
        {value: "班次管理"}
      ],
      addAccountRouterName: "personnel-on-duty-classes-add",

      searchPlaceholder: "班次名称",
      searchKey: "",
      deleteTipInfo: "是否确认删除该班次？",
      tableHead: [
        {prop: "routeName", label: "班次名称"},
        {prop: "description", label: "班次描述"},
        {prop: "code", label: "班次时间", isLooking: true},
        {prop: "memo", label: "备注"}
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ["modify", "delete"],

      classesTimeTitle: '班次时间',
      classesTimeDialogVisible: false,
      currentClassesInfo: {
        monTimes: [],
        tueTimes: [],
        wedTimes: [],
        thuTimes: [],
        friTimes: [],
        satTimes: [],
        sunTimes: [],
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getPage();
  },
  methods: {
    // 查看班次时间
    viewClassesTime (row) {
      this.classesTimeTitle = `${row.routeName}班次时间`
      this.currentClassesInfo = row
      this.classesTimeDialogVisible = true
    },

    getPage() {
      this.$axios.post(api.getParkingEmergencyRoutePage, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey
        })
        .then(res => {
          this.total = res.data.data.total;
          let data = res.data.data.list;
          this.tableData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },
    // 修改
    goToModifyPage(code) {
      this.$router.push({
        path: `/park_server/personnel_on_duty_classes_modify/${code}`
      });
    },
    // 删除
    deleteLine(code) {
      this.$axios.post(api.deleteParkingEmergencyRouteByCodes, code)
        .then(res => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    }
  }
};
</script>

<style scoped lang="less">
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.personnel-on-duty-classes-manage {
  .el-dialog {
    .classes-time-main {
      padding: 0 10px;
      .classes-time-line {
        font-size: 14px;
        line-height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .classes-time-title {
          color: #333333;
          margin-right: 10px;
        }
        .classes-time-no-tip {
          color: #666666;
        }
        .classes-time-info {
          flex: 1;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-wrap: wrap;
          .classes-time-info-item {
            margin-right: 10px;
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesManage.vue